// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { hartfordBlocks } from 'apps/ng/src/app/components/UI/Form/hartford';

const toOneLineString = (value: string | undefined | null) =>
  (value || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .join(' ')
    .replace(/"/g, '\\"');

export const insuranceProposalTheme = `
    * {
    box-sizing: border-box; /* Ensures padding and border are included in the total width and height of elements */
  }

  html, body {
    position: relative;
    margin: 0;
    padding: 0;
    line-height: 1.6;
    font-family: Arial, sans-serif; /* Fallback font family */
    min-height: 100vh;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }

  a {
    color: inherit; /* Inherit color from parent element */
    text-decoration: none; /* Remove underline */
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
  }

    :root {
      --primary-color: #0B0758;
      --accent-color: #006CFF;
      --medium-grey-color: #CFCFCF;
      --page-color: #F5F5F5;
      --grey-background: #F1F1F1;
      --text-line-height: 1.9rem;

      --color-blue1: #0B0758;
      --color-darkGrey: #595959;
      --color-divider: #ccc;

      --text-white: #FFF;
      --text-dark: black;

      --font-size: 16px;
      --font-size-small: 14px;
      --font-size-text: 24px;
      --font-size-h1: 32px;
      --font-size-h2: 28px;
      --font-size-h3: 24px;
      --font-size-large: 48px;
      --font-family: Arial, sans-serif;

      --size-avatar-default: 124px;

      --padding-default: 1rem 2rem;
      --padding-small: 1rem;
      --page-max-width: 1440px;

      --spacing-default: 1.2rem;

      --transition-default: all 0.3s ease;
    }

    html, body {
      font-family: var(--font-family);
      background-color: var(--page-color);
    }

    p {
      font-size: var(--font-size-text);
      line-height: var(--text-line-height);
    }

    h1 {
      font-size: var(--font-size-h1);
    }

    h2 {
      font-size: var(--font-size-h2);
    }

    h3 {
      font-size: var(--font-size-h3);
    }

    .text-align-right {
      text-align: right;
    }

    .text-align-center {
      text-align: center;
    }

    .text-align-bottom {
      vertical-align: bottom;
    }

    .mt-1 {
      margin-top: 1rem;
    }

    .mt-2 {
      margin-top: 4rem;
    }

    .page-section {
      padding: 4rem 0;
      border-top: 1px solid var(--color-divider);
      min-height: 70vh;
    }

    .details-list {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-default);
    }

    .details-list ul {
        padding: 0 1.2rem;
        margin: 0;
        font-size: var(--font-size-text);
    }

    #scroll-to-top-button {
      cursor: pointer;
      position: fixed;
      bottom: 2vh;
      right: 6vw;
      z-index: 10;

      padding: 10px;
    }

    #scroll-to-top-button img {
      width: 50px;
      height: auto;
    }

    .table-container {
      width: 100%;
      overflow: auto;
    }

    .table-row-accent {
      font-weight: bold;
      color: var(--color-blue1);
      border-top: 4px solid var(--color-blue1);
      border-bottom: 4px solid var(--color-blue1);
    }

    .table-row-accent-thin {
      font-weight: bold;
      color: var(--color-blue1);
      border-top: 2px solid var(--color-blue1);
      border-bottom: 2px solid var(--color-blue1);
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;
      font-size: var(--font-size-text);
    }

    table th, table td {
      padding: 10px 15px;
      text-align: left;
    }

    table th {
      color: var(--color-blue1);
      font-weight: bold;
      border-top: 6px solid var(--color-blue1);
      border-bottom: 6px solid var(--color-blue1);
    }

    table tr td {
      border-bottom: 1px solid var(--color-darkGrey);
    }


    .mb-1 {
      margin-bottom: 10px;
    }

    .mb-2 {
      margin-bottom: 4rem;
    }

    .no-margin {
      margin: 0;
    }

    .body-container {
      display: flex;
      gap: 1rem;
      width: 100%;
    }

    .page {
      width: 100%;
    }

    .accent-color {
      color: var(--accent-color);
    }

    .info-section {
      background-color: var(--grey-background);
      padding: var(--padding-default);
    }

    .info-section-content {
      display: flex;
      justify-content: space-between;
    }

    .page-container {
      position: relative;
      width: 100%;
      height: 100%;
      padding: var(--padding-default);
    }

    .main-container {
      margin: auto;
      max-width: var(--page-max-width);
    }

    hr {
       border: 1px solid var(--color-divider);
       margin: 20px 0;
    }

    .page-container hr {
      margin-top: 3rem;
    }

    .font-small {
      font-size: var(--font-size-small);
    }

    .side-nav {
      position: relative;
      background-color: var(--grey-background);
      min-width: 385px;
      min-height: 40vh;
      border-bottom: 8px solid var(--page-color);
    }

    .side-nav-content {
      position: sticky;
      position: -webkit-sticky;
      top: 80px;
    }

    #side-nav-button {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 1rem 0.5rem ;
      gap: 0.5rem;
      height: 62px;
    }

    #side-nav-chevron-left {
      display: inline;
    }

    #side-nav-hamburger {
      display: none;
    }

    .side-nav.collapsed #side-nav-chevron-left,
    .side-nav.collapsed #side-nav-menu-title,
    .side-nav.collapsed ul {
      display: none;
    }

    .side-nav.collapsed #side-nav-hamburger {
      display: inline-block;
    }

    .side-nav.collapsed {
        min-width: 60px;
        padding-left: 0.5rem;
    }

    .side-nav ul {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .side-nav li a {
      display: block;
      padding: var(--padding-default);
      padding-left: 3rem;
      transition: background-color 0.3s ease;
      user-select: none;
      font-size: 16px;
    }

     .side-nav li.active {
      pointer-events: none;
      background-color: var(--primary-color);
      color: var(--text-white);
      font-weight: bold;
    }

    .side-nav li:hover {
      cursor: pointer;
      background: lightgrey;
    }

    .side-nav-menu-title {
      font-size: 20px;
    }

    .top-nav {
    position: sticky;
    min-height: 80px;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 10;
    border-bottom: none;
    display: flex;
    align-items: center;

    -webkit-box-align: center;
    background-color: var(--primary-color);
    color: var(--text-white);

    display: flex;
    flex-direction: column;
  }

  .top-nav-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    padding: 0 1rem;
    width: 100%;
  }

  .logo img {
    width: 238px;
  }

  #top-nav-menu-links {
    background: lightgrey;
    width: 100%;
    padding: var(--padding-default);
    color: var(--text-dark)!important;
  }

  #top-nav-menu-links ul {
    position: relative;
    display: flex;
    gap: 1rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  #top-nav-menu-links ul li a:hover {
    text-decoration: underline;
  }

  #top-nav-menu-links ul li a::after {
    content: "|";
    margin-left: 0.5rem;
    font-weight: normal;
    font-size: 15px;
  }

  #top-nav-menu-links ul li:last-child a::after {
    content: "";
  }

  #top-nav-menu-links .active {
    pointer-events: none;
    font-weight: bold;
  }

  #top-nav-links {
    display: flex;
    font-size: 16px;
    font-weight: bold;
    gap: 1rem;
  }

  #top-nav-links a {
    position: relative;
    padding-right: 1rem;
  }

  #top-nav-links a::after {
    content: "|";
    position: absolute;
    right: -2px;
    top: 0;
    font-weight: normal;
    font-size: 15px;
  }

  #top-nav-links a:last-child::after {
    content: "";
  }

  #top-nav-links a:last-child {
    padding-right: 0;
  }

  #hamburger-menu {
    display: none;
  }

  .top-nav .customer-name {
    font-size: var(--font-size-text);
  }

  .nav-link, .customer-name {
      color: var(--text-white);
  }

   #mobile-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--page-color);
    display: none;
    overflow-y: auto;
    z-index: 1000;
    color: var(--text-dark);
  }

  #mobile-nav .mobile-nav-header {
    font-size: 20px;
    font-weight: bold;
    padding: var(--padding-default);
    border-bottom: 1px solid var(--medium-grey-color);
  }

  #mobile-nav ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  #mobile-nav li {
    // margin: 1rem 0;
    padding: 1rem 4rem;
    border-bottom: 1px solid var(--medium-grey-color);
  }

  #mobile-nav li.active {
    font-weight: bold;
    color: var(--accent-color);
  }

  #mobile-nav li a {
    text-decoration: none;
    font-size: var(--font-size-small);
  }

  #mobile-nav.visible {
    display: block;
  }

  #top-nav-menu-links {
   color: white;
  }

     .section {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: flex-start;
    color: black;
    margin: auto;
  }

  .section-content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: auto;
  }

  .section-grid {
    display: grid;
    width: 100%;
    margin: auto;
  }

  .section h2 {
    padding: 0px 0px 20px;
    font-weight: bold;
    margin: 0px;
    color: rgb(0, 38, 119);
    font-size: 28px;
    letter-spacing: 0.7px;
    line-height: 58px;
  }

    .footer {
      padding: 3rem 0;
      background-color: var(--grey-background);
    }

    .footer-container {
      padding: 0 1rem;
    }

    .footer-header {
      display: flex;
      justify-content: space-between;
      font-size: var(--font-size-text);
      margin-bottom: 30px;
    }

    .footer-container p {
      margin: 0;
      line-height: 1.3rem;
    }

    #footer-logo {
      max-width: 238px;
    }

    .microsite-title {
      text-align: center;
      font-size: var(--font-size-large);
    }

    .page-title {
      text-align: center;
      color: var(--accent-color);
      font-size: var(--font-size-h1);
      text-transform: uppercase;
    }

    .banner {
      width: 100%;
      height: 450px;
      position: relative;
      overflow: hidden;
    }

    .banner img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .insurance-proposal-header {
      text-align: center;
      font-size: 24px;
      line-height: 0.7rem;
    }

    .person-block {
      max-width: 380px;
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .person-block .avatar {
      margin-bottom: 1rem;
    }

    .person-block p {
      margin: 0;
    }

    .person-block .contacts {
      margin-top: 0.3rem;
    }

    .person-block .contacts a {
      display: block;
      font-size: var(--font-size-text);
      transition: var(--transition-default);
    }

    .person-block .name {
      font-weight: bold;
    }

    .person-block .contacts a:hover {
      color: var(--accent-color);
      text-decoration: underline;
      transition: var(--transition-default);
    }

    .avatar{
      max-width: var(--size-avatar-default);
      max-height: var(--size-avatar-default);
    }

    .person-block .role {
      color: var(--accent-color);
      font-weight: bold;
    }

     @media (max-width: 500px) {
        .insurance-proposal-header strong {
          display: block;
          margin-top: 0.7rem;
        }

        .section-grid {
          display: flex;
          flex-direction: column;
        }
     }

     @media (max-width: 1380px) {
      :root {
        --font-size-small: 12px;
        --font-size-text: 14px;
        --font-size-h1: 20px;
        --font-size-h2: 18px;
        --font-size-h3: 14px;
        --font-size-large: 24px;

        --text-line-height: 1.3rem;
        --size-avatar-default: 96px;
      }

      #top-nav-menu-links {
        display: none;
      }

      .top-nav .customer-name {
        font-size: var(--font-size-h1);
      }

      .top-nav .logo img {
        max-width: 172px;
        flex: 1;
      }

      .top-nav p {
        margin: 0;
      }

      .side-nav {
        display: none;
      }

      .body-container {
        display: flex;
      }

      .top-nav-content {
        padding: 20px;
        flex-direction: column;
        gap: 1rem;
      }

      #top-nav-links {
        display: none;
      }

     .insurance-proposal-header strong {
        margin-top: 0;
      }

      #footer-logo {
        max-width: 139px;
      }

      #hamburger-menu {
        display: inline-block;
        cursor: pointer;
        margin: auto 0;
      }

      #top-nav-menu-section {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }


      table th {
        border-top: 4px solid var(--color-blue1);
        border-bottom: 4px solid var(--color-blue1);
      }

      .table-row-accent {
        border-top: 2px solid var(--color-blue1);
        border-bottom: 2px solid var(--color-blue1);
      }
    }
}
`;

const optumTheme = `
  .site-container {
    position: relative;
    width: 100%;
    max-width: 1200px;
    margin: auto
  }

  .resources-list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
  }

 .resources-list-vertical {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
}

.resources-list-vertical li {
  padding: 1rem;
}

.resources-list-vertical li a {
  font-weight: bold;
  text-decoration: none;
  color: blue;
  transition: text-decoration 0.2s ease;
}

.resources-list-vertical li a:hover {
  text-decoration: underline;
}

  .resource-card {
    min-width: 0;
    box-sizing: border-box;
    font-size: 14px;
  }

  .resource-title {
    color: rgb(0, 38, 119);
    text-transform: capitalize;
    font-weight: bold;
    text-decoration: none;
  }

  .resource-description  {
    font-size: 14px;
    margin: 10px 0px;
    font-weight: 400;
  }

  .banner-content {
  display:flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  padding: 0px;
  min-height: 390px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-width: 320px;
  max-width: 1280px;
  margin: 0px auto;
  position: relative;
  z-index: 2;
}

.banner-details {
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-flex: 1;
    flex-grow: 1;
    flex-basis: 300px;
    line-height: 1.4;
    min-width: 320px;
    max-width: 500px;
    margin: 32px 0px;
    padding: 0px 4px;
    background-color: transparent;
}

.banner-details h1 {
    color: rgb(0, 38, 119);
    font-size: 46px;
    line-height: 1.2;
    margin: 0px;
    padding: 0px;
    font-weight: 700;
}

.banner-details p {
    font-size: 28px;
    color: rgb(90, 90, 90);
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 0px;
}

.banner-background {
    display: block;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: right center;
    position: absolute;
    top: 0px;
    right: 0px;
    height: 100%;
    width: 100%;
    z-index: -1;
  }

  .team-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    box-sizing: border-box;
  }

  .person-block {
    flex: 0 0 calc(25% - 1rem);
    box-sizing: border-box;
    padding: 30px;
    border-radius: 5px;
    height: 100%;
    min-width: 60px;
  }

  .person-block .person-name {
    color: rgb(0, 38, 119)
  }

  .avatar {
    border-radius: 50%;
    width: 85px;
    height: 85px;
    margin-right: 10px;
    background-size: cover;
    background-position: center center;
    flex-shrink: 0;
    overflow: hidden;
  }

  .avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .top-nav {
    position: sticky;
    min-height: 82px;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 10;
    background-color: rgb(251, 249, 244);
    background-color: red;
    border-bottom: none;
    display: flex;
    justify-content: space-between;
  }

.top-nav-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  max-width: 1300px;
  padding: 0 8px;
  min-width: 320px;
  margin: 0 auto;
}

  .top-nav .brand-text {
      max-width: 100%;
      flex: 1 1 0%;
      letter-spacing: -0.1px;
      font-weight: 400;
      font-size: 44px;
      color: rgb(90, 90, 90);
  }

  .top-nav .logo {
      display: block;
      height: 48px;
      margin: 8px 0px;
      transform: translateX(-5px) translateY(4px);
  }

  .top-nav .logo img {
    display: block;
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  .top-nav .separator {
      border-left: 1px solid rgb(90, 90, 90);
      height: 38px;
  }

.brand-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0;
}

  .footer-light {
  position: -webkit-sticky;
  // position: sticky;
  margin-top: 20px;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;

  color: rgb(99, 99, 99);
  font-size: 12.64px;

  font-family: optumsans-regular, sans-serif, Arial;
}

.footer-light .container {
  display: flex;
  padding: 0 20px;
  box-sizing: border-box;
  gap: 20px;
}

.footer-links {
  display: flex;
  gap: 12px;
  padding: 0;
  margin: 0;
}

.footer-links li  {
  border-left: 1px solid rgb(224, 224, 224);
  padding: 0px 10px;
}

  .resources-column li {
    margin-bottom: 16px;
  }

  .resources-column a span {
    text-transform: capitalize;
    font-weight: 200;
    color: rgb(25, 110, 207);
  }

  #scroll-to-top-button {
    cursor: pointer;
    position: fixed;
    bottom: 2vh;
    right: 6vw;
    z-index: 10;

    padding: 10px;
  }

  #scroll-to-top-button img {
    width: 50px;
    height: auto;
  }

  .grey-background {
    background-color: rgb(244, 244, 244);
  }

  .page-section {
    min-width: 300px;
    max-width: 1153px;
    padding: 24px;
    border: none;
    border-radius: 0px;
  }
`;

const serviceTeamBlock = `
    <section id="service-team" class="page-section">
        <h1 class="page-title">{{ ServiceTeam.SectionTitle }}</h1>

        <p>{{ ServiceTeam.Description }}</p>

        {{> cothromTeamBlock data=ServiceTeam.Data }}
    </section>
`;

const scrollToTopButton = {
  id: 119,
  jsId: 3,
  name: 'scrollToTopButton',
};

export const insuranceProposalLayoutBlocks: HtmlTemplateBlock[] = [
  {
    id: 118,
    jsId: 1,
    name: 'sideNav',
  },
  {
    id: 115,
    name: 'cothromPersonBlock',
  },
  {
    id: 117,
    jsId: 2,
    name: 'cothromTopNav',
  },
  {
    id: 11,
    name: 'sectionColumns',
  },
  {
    id: 114,
    name: 'cothromBannerBlock',
  },
  {
    id: 120,
    name: 'insuranceProposalHeader',
  },
  scrollToTopButton,
];

export const layoutsBlocksMock: HtmlBlock[] = [
  {
    ID: 121,
    Name: 'cothrom/insuranceProposalLayout',
    DisplayName: 'Cothrom Insurance Proposal Layout',
    Html: '{{> cothromTopNav }}  <div class=\\"main-container\\"> {{> cothromBannerBlock imageUrl=Project.HeroImage }} </div>  <div class=\\"body-container main-container\\"> {{> sideNav }}  <div class=\\"page-container\\"> <h1 class=\\"microsite-title\\">{{ Project.DisplayName }}</h1>  {{> insuranceProposalHeader }}  <div class=\\"mt-2\\"></div>  {{> scrollToTopButton }}  {{> @partial-block }} </div> </div>  <footer class=\\"footer\\"> <div class=\\"main-container footer-container\\"> <div class=\\"footer-header\\"> <img id=\\"footer-logo\\" src=\\"{{Project.Footer.LogoUrl}}\\" alt=\\"logo\\" /> <h5>{{Project.Footer.Title}}</h5> </div>  <p class=\\"font-small\\">{{ Project.Footer.Note }}</p> <p class=\\"font-small\\"> Proposal date: {{formatDate ProposalDate}}</p> </div> </footer>',
    CreatedAt: '2025-05-08T11:34:12.188Z',
    UpdatedAt: '2025-05-08T11:34:12.188Z',
    Blocks: insuranceProposalLayoutBlocks,
    cssId: 1,
    Css: insuranceProposalTheme,
  },
  {
    ID: 999,
    Name: 'hartford/NavLayout',
    DisplayName: 'Hartford Nav Layout',
    Html: hartfordBlocks.find((h) => h.name === 'hartford/NavLayout')?.partial || '',
    CreatedAt: '2025-05-08T11:34:12.188Z',
    UpdatedAt: '2025-05-08T11:34:12.188Z',
    Blocks: hartfordBlocks,
    Css: hartfordBlocks.map((b) => b.css).join('\n\n'),
    SkipFetch: true,
  },
  {
    ID: 97,
    Name: 'optumWithHeroBannerLayout',
    DisplayName: 'Optum With Hero Banner',
    SkipFetch: true,
    Html: ` <div class="site-container">
      {{> topNavSection }}

      <div style="max-width: 1200px; margin: auto">
      {{> bannerBlock }}

      <main>
      {{> @partial-block }}
      </main>

      {{> footerLightBlock }}
    </div>
  </div>`,
    Css: optumTheme,
    CreatedAt: '2025-05-08T11:34:12.188Z',
    UpdatedAt: '2025-05-08T11:34:12.188Z',
    Blocks: [
      {
        name: 'topNavSection',
      },
      {
        name: 'bannerBlock',
      },
      {
        name: 'footerLightBlock',
      },
    ],
  },
  {
    ID: 98,
    Name: 'optumCleanLayout',
    DisplayName: 'Optum Clean',
    SkipFetch: true,
    Html: `
    <div class="site-container">
      {{> topNavSection }}

      <div style="max-width: 1200px; margin: auto">

      <main>
      {{> @partial-block }}
      </main>

      {{> footerLightBlock }}
      </div>
  </div>
    `,
    Css: optumTheme,
    Blocks: [
      {
        name: 'topNavSection',
      },
      {
        name: 'footerLightBlock',
      },
    ],
    CreatedAt: '2025-05-08T11:34:12.188Z',
    UpdatedAt: '2025-05-08T11:34:12.188Z',
  },
  {
    ID: 100,
    Name: 'optumWithoutTopNavLayout',
    DisplayName: 'Optum Without Top Nav',
    SkipFetch: true,
    Html: `
    <div  class="site-container">

    <main>
    {{> @partial-block }}
    </main>

    {{> footerLightBlock }}
    </div>
    `,
    Css: optumTheme,
    Blocks: [
      {
        name: 'footerLightBlock',
      },
    ],
    CreatedAt: '2025-05-08T11:34:12.188Z',
    UpdatedAt: '2025-05-08T11:34:12.188Z',
  },
];

const optumBlocks: HtmlBlock[] = [
  {
    ID: 99,
    Name: 'teamBlock',
    DisplayName: 'Team',
    Html: `
      <section class="team-list page-section">
         {{#each Team }}
             <div class="person-block">
               <div class="avatar">
                  <img src="{{IMAGE_URL}}" alt="person photo" />
              </div>
              <div>
                  <h4 class="person-name">{{FIRST_NAME}} {{LAST_NAME}}</h4>
                  <p>Email: {{EMAIL}}</p>
                  <p>Phone: 676 767 676}</p>
              </div>
            </div>
         {{/each}}
      </section>
    `,
  },
  {
    Name: 'resourceVerticalBlock',
    DisplayName: 'Resource Vertical',
    Html: `
      <section class="grey-background page-section">
          <h2 class="title">Resources</h2>

          <br />

          <ul class="resources-list-vertical">
            {{# each Resources }}
              <li><a href="https://google.com" title="{{TITLE}}" target="_blank" rel="noopener noreferrer"><span>{{TITLE}}</span></a></li>
            {{/each }}
          </ul>
      </section>
    `,
  },
  {
    Name: 'topNavSection',
    DisplayName: 'Top Nav',
    Html: `
    <nav class="top-nav" style="background-color: white">
      <div class="top-nav-content container">
        <div class="brand-header">
            <a class="logo" href="/">
                <img src="https://dev.msmsites.coley.clatter.io/optum.png" alt="logo" />
            </a>
        </div>
      </div>
    </nav>
    `,
  },
  {
    Name: 'bannerBlock',
    DisplayName: 'Banner',
    Html: `
      <div class="banner-content">
        <div class="banner-details">
          <h1>Sample Banner Title</h1>
          <p>Subtitle banner</p>
          <a class="resource-title" href="http://google.com" target="_blank" rel="noopener noreferrer" style="margin-top: 20px;"><span >Google Link</span></a>
        </div>
        <div class="banner-background" style="background-image: url('https://clatter-mediatavern-prod-cms.s3.us-east-1.amazonaws.com/Web_banner_7_3ae5dd3ec5_b7af06ec52.jpg')"></div>
      </div>
    `,
  },
  {
    Name: 'resourceBlock',
    DisplayName: 'Resources',
    Html: `
      <section class="page-section">
        <h2 class="title">Resources</h2>

        <br />

        <div class="resources-list">
          {{#each Resources }}
          <div class="resource-card">
            <a class="resource-title" href="https://enterpriseinsure.com/resources/corporate-policy-2025.pdf" title="{{TITLE}}" target="_blank" rel="noopener noreferrer"><span>{{TITLE}}</span></a>
            <p class="resource-description">{{DESCRIPTION}}</p>
          </div>
          {{/each}}
        </div>
      </section>
    `,
  },
  {
    Name: 'footerLightBlock',
    DisplayName: 'Footer Light',
    Html: `
      <div class="container">
        © 2025 Optum, Inc. All rights reserved.
        <ul class="footer-links">
            <li><a href="https://google.com">Privacy policy</a></li>
            <li><a href="https://google.com">Terms Of Use</a></li>
            <li><a href="https://google.com">Opt out</a></li>
            <li><a href="https://google.com">Accessibility</a></li>
            <li><a href="https://google.com">Site map</a></li>
        </ul>
      </div>
    `,
  },
];

const cothromBlocks: HtmlBlock[] = [
  {
    ID: 113,
    Name: 'sectionColumns',
    DisplayName: 'Section Columns',
  },
  {
    ID: 114,
    Name: 'cothromBannerBlock',
    DisplayName: 'Cothrom Banner Block',
  },
  {
    ID: 115,
    Name: 'cothromPersonBlock',
    DisplayName: 'Cothrom Person Block',
  },
  {
    ID: 116,
    Name: 'cothromTeamBlock',
    DisplayName: 'Cothrom Team Block',
  },
  {
    ID: 117,
    Name: 'cothromTopNav',
    DisplayName: 'Cothrom Top Nav',
  },
  {
    ID: 118,
    Name: 'sideNav',
    DisplayName: 'Side Nav (Sections)',
  },
  {
    ID: 119,
    Name: 'scrollToTopButton',
    DisplayName: 'Scroll To Top Button',
  },
  {
    ID: 120,
    Name: 'insuranceProposalHeader',
    DisplayName: 'Insurance Proposal Header',
  },
  // sections
  {
    ID: 103,
    Name: 'cothrom/disclaimerAndConfidentiality',
    DisplayName: 'Cothrom/Disclaimer & Confidentiality',
  },
  {
    ID: 104,
    Name: 'cothrom/serviceTeam',
    DisplayName: 'Cothrom/Service Team',
  },
  {
    ID: 105,
    Name: 'cothrom/premiumSummary',
    DisplayName: 'Cothrom/Premium Summary',
  },
  {
    ID: 106,
    Name: 'cothrom/propertyXWind',
    DisplayName: 'Cothrom/Property (X-wind)',
  },
  {
    ID: 107,
    Name: 'cothrom/generalLiability',
    DisplayName: 'Cothrom/General Liability',
  },
  {
    ID: 108,
    Name: 'cothrom/crime',
    DisplayName: 'Cothrom/Crime',
  },
  {
    ID: 109,
    Name: 'cothrom/excessLiabilityPrimaryLayer',
    DisplayName: 'Cothrom/Excess Liability',
  },
  {
    ID: 110,
    Name: 'cothrom/networkSecurityAndPrivacyLiability',
    DisplayName: 'Cothrom/Network Security & Privacy Liability',
  },
  {
    ID: 111,
    Name: 'cothrom/stockThroughPutOceanCargo',
    DisplayName: 'Cothrom/Stock through put / Ocean Cargo',
  },
  {
    ID: 112,
    Name: 'cothrom/commercialAuto',
    DisplayName: 'Cothrom/Commercial Auto',
  },
];

export const workspaceBlocksMockByTemplateNameMock: { [key: string]: HtmlBlock[] } = {
  'hartford/NavLayout': hartfordBlocks.map((h, idx) => ({
    Id: 1000 + idx,
    Name: h.name,
    DisplayName: h.name,
    Html: h.partial,
  })),
  optumCleanLayout: [...optumBlocks],
  optumWithHeroBannerLayout: [...optumBlocks],
  optumWithoutTopNavLayout: [...optumBlocks],
  'cothrom/insuranceProposalLayout': cothromBlocks,
};
